import { render, staticRenderFns } from "./menutabs.vue?vue&type=template&id=6fa4b7c8&scoped=true&"
import script from "./menutabs.vue?vue&type=script&lang=js&"
export * from "./menutabs.vue?vue&type=script&lang=js&"
import style0 from "./menutabs.vue?vue&type=style&index=0&id=6fa4b7c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa4b7c8",
  null
  
)

export default component.exports